// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer_footer__1L1AL","content":"footer_content__zUd76","link":"footer_link__sTE5u","linkActive":"footer_linkActive__3vFsr"};